<div class="next-story-card">
  <div class="next-story-card__title">
    <span>Weiter zu:</span>
  </div>

  <ul class="next-story-card__stories">
    <li *ngFor="let story of data.stories">
      <brt-next-story-preview [story-preview]="story"></brt-next-story-preview>
    </li>
  </ul>
</div>
